import {
  LinkedHashSetClassDesc202cqq5740j6e as LinkedHashSetClassDesc,
  ArrayListClassDesc2euexqfjnihq7 as ArrayListClassDesc,
  HashSetClassDesc1sva99tssxbb4 as HashSetClassDesc,
  HashMapClassDesc33bep136pd9y6 as HashMapClassDesc,
  LinkedHashMapClassDesc1yxtovbec4ruk as LinkedHashMapClassDesc,
  ArrayClassDesc2voesact8ugbc as ArrayClassDesc,
  PrimitiveArrayDescriptor3bvg9e2uulc3b as PrimitiveArrayDescriptor,
} from './CollectionDescriptors.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtSetjrjc7fhfd6b9 as KtSet,
  KtList3hktaavzmj137 as KtList,
  KtMap140uvy3s5zad8 as KtMap,
  Collection1k04j3hzsbod0 as Collection,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isArray1hxjqtqy632bc as isArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { arrayIterator3lgwvgteckzhv as arrayIterator } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { toNativeArrayImpl3ha7yn5cjhfpi as toNativeArrayImpl } from './Platform.mjs';
import { asList2ho2pewtsfvv as asList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { PrimitiveKindndgbuh6is7ze as PrimitiveKind } from '../descriptors/SerialKinds.mjs';
import { getValue48kllevslyh6 as getValue } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var LinkedHashSetSerializerClass;
function LinkedHashSetSerializer() {
  if (LinkedHashSetSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(eSerializer) {
        super(eSerializer);
        this.f1u_1 = new (LinkedHashSetClassDesc())(eSerializer.m1m());
      }
      m1m() {
        return this.f1u_1;
      }
      g1u() {
        // Inline function 'kotlin.collections.linkedSetOf' call
        return LinkedHashSet().s2();
      }
      h1u(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      i1u(_this__u8e3s4) {
        return this.h1u(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      j1u(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      k1u(_this__u8e3s4) {
        return this.j1u(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      l1u(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? LinkedHashSet().c3(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      m1u(_this__u8e3s4) {
        return this.l1u((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      n1u(_this__u8e3s4, size) {
      }
      o1u(_this__u8e3s4, size) {
        return this.n1u(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      p1u(_this__u8e3s4, index, element) {
        _this__u8e3s4.i2(element);
      }
      q1u(_this__u8e3s4, index, element) {
        return this.p1u(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'LinkedHashSetSerializer');
    LinkedHashSetSerializerClass = $;
  }
  return LinkedHashSetSerializerClass;
}
var ArrayListSerializerClass;
function ArrayListSerializer() {
  if (ArrayListSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(element) {
        super(element);
        this.b1v_1 = new (ArrayListClassDesc())(element.m1m());
      }
      m1m() {
        return this.b1v_1;
      }
      g1u() {
        // Inline function 'kotlin.collections.arrayListOf' call
        return ArrayList().p2();
      }
      c1v(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      i1u(_this__u8e3s4) {
        return this.c1v(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      d1v(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      k1u(_this__u8e3s4) {
        return this.d1v(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      e1v(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? ArrayList().j2(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      m1u(_this__u8e3s4) {
        return this.e1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      f1v(_this__u8e3s4, size) {
        return _this__u8e3s4.h8(size);
      }
      o1u(_this__u8e3s4, size) {
        return this.f1v(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      g1v(_this__u8e3s4, index, element) {
        _this__u8e3s4.b5(index, element);
      }
      q1u(_this__u8e3s4, index, element) {
        return this.g1v(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'ArrayListSerializer');
    ArrayListSerializerClass = $;
  }
  return ArrayListSerializerClass;
}
var HashSetSerializerClass;
function HashSetSerializer() {
  if (HashSetSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(eSerializer) {
        super(eSerializer);
        this.i1v_1 = new (HashSetClassDesc())(eSerializer.m1m());
      }
      m1m() {
        return this.i1v_1;
      }
      g1u() {
        return HashSet().ga();
      }
      j1v(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      i1u(_this__u8e3s4) {
        return this.j1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      k1v(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      k1u(_this__u8e3s4) {
        return this.k1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      l1u(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? HashSet().ha(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      m1u(_this__u8e3s4) {
        return this.l1u((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      l1v(_this__u8e3s4, size) {
      }
      o1u(_this__u8e3s4, size) {
        return this.l1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      m1v(_this__u8e3s4, index, element) {
        _this__u8e3s4.i2(element);
      }
      q1u(_this__u8e3s4, index, element) {
        return this.m1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'HashSetSerializer');
    HashSetSerializerClass = $;
  }
  return HashSetSerializerClass;
}
var HashMapSerializerClass;
function HashMapSerializer() {
  if (HashMapSerializerClass === VOID) {
    class $ extends MapLikeSerializer() {
      constructor(kSerializer, vSerializer) {
        super(kSerializer, vSerializer);
        this.p1v_1 = new (HashMapClassDesc())(kSerializer.m1m(), vSerializer.m1m());
      }
      m1m() {
        return this.p1v_1;
      }
      q1v(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      r1v(_this__u8e3s4) {
        return this.q1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      s1v(_this__u8e3s4) {
        // Inline function 'kotlin.collections.iterator' call
        return _this__u8e3s4.l3().p1();
      }
      t1v(_this__u8e3s4) {
        return this.s1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      g1u() {
        return HashMap().r8();
      }
      u1v(_this__u8e3s4) {
        return imul(_this__u8e3s4.q2(), 2);
      }
      i1u(_this__u8e3s4) {
        return this.u1v(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      v1v(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      k1u(_this__u8e3s4) {
        return this.v1v(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      w1v(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? HashMap().g9(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      m1u(_this__u8e3s4) {
        return this.w1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      x1v(_this__u8e3s4, size) {
      }
      o1u(_this__u8e3s4, size) {
        return this.x1v(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE(), size);
      }
    }
    initMetadataForClass($, 'HashMapSerializer');
    HashMapSerializerClass = $;
  }
  return HashMapSerializerClass;
}
var LinkedHashMapSerializerClass;
function LinkedHashMapSerializer() {
  if (LinkedHashMapSerializerClass === VOID) {
    class $ extends MapLikeSerializer() {
      constructor(kSerializer, vSerializer) {
        super(kSerializer, vSerializer);
        this.e1w_1 = new (LinkedHashMapClassDesc())(kSerializer.m1m(), vSerializer.m1m());
      }
      m1m() {
        return this.e1w_1;
      }
      q1v(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      r1v(_this__u8e3s4) {
        return this.q1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      s1v(_this__u8e3s4) {
        // Inline function 'kotlin.collections.iterator' call
        return _this__u8e3s4.l3().p1();
      }
      t1v(_this__u8e3s4) {
        return this.s1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      g1u() {
        return LinkedHashMap().bc();
      }
      f1w(_this__u8e3s4) {
        return imul(_this__u8e3s4.q2(), 2);
      }
      i1u(_this__u8e3s4) {
        return this.f1w(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      g1w(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      k1u(_this__u8e3s4) {
        return this.g1w(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      w1v(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? LinkedHashMap().dc(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      m1u(_this__u8e3s4) {
        return this.w1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      h1w(_this__u8e3s4, size) {
      }
      o1u(_this__u8e3s4, size) {
        return this.h1w(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE(), size);
      }
    }
    initMetadataForClass($, 'LinkedHashMapSerializer');
    LinkedHashMapSerializerClass = $;
  }
  return LinkedHashMapSerializerClass;
}
var ReferenceArraySerializerClass;
function ReferenceArraySerializer() {
  if (ReferenceArraySerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      constructor(kClass, eSerializer) {
        super(eSerializer);
        this.j1w_1 = kClass;
        this.k1w_1 = new (ArrayClassDesc())(eSerializer.m1m());
      }
      m1m() {
        return this.k1w_1;
      }
      l1w(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      r1v(_this__u8e3s4) {
        return this.l1w((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      m1w(_this__u8e3s4) {
        return arrayIterator(_this__u8e3s4);
      }
      t1v(_this__u8e3s4) {
        return this.m1w((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      g1u() {
        // Inline function 'kotlin.collections.arrayListOf' call
        return ArrayList().p2();
      }
      n1w(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      i1u(_this__u8e3s4) {
        return this.n1w(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      o1w(_this__u8e3s4) {
        return toNativeArrayImpl(_this__u8e3s4, this.j1w_1);
      }
      k1u(_this__u8e3s4) {
        return this.o1w(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      p1w(_this__u8e3s4) {
        return ArrayList().j2(asList(_this__u8e3s4));
      }
      m1u(_this__u8e3s4) {
        return this.p1w((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      q1w(_this__u8e3s4, size) {
        return _this__u8e3s4.h8(size);
      }
      o1u(_this__u8e3s4, size) {
        return this.q1w(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      r1w(_this__u8e3s4, index, element) {
        _this__u8e3s4.b5(index, element);
      }
      q1u(_this__u8e3s4, index, element) {
        return this.r1w(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'ReferenceArraySerializer');
    ReferenceArraySerializerClass = $;
  }
  return ReferenceArraySerializerClass;
}
var CollectionSerializerClass;
function CollectionSerializer() {
  if (CollectionSerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      s1u(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      r1v(_this__u8e3s4) {
        return this.s1u((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      t1u(_this__u8e3s4) {
        return _this__u8e3s4.p1();
      }
      t1v(_this__u8e3s4) {
        return this.t1u((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
    }
    initMetadataForClass($, 'CollectionSerializer');
    CollectionSerializerClass = $;
  }
  return CollectionSerializerClass;
}
var MapLikeSerializerClass;
function MapLikeSerializer() {
  if (MapLikeSerializerClass === VOID) {
    class $ extends AbstractCollectionSerializer() {
      constructor(keySerializer, valueSerializer) {
        super();
        this.y1v_1 = keySerializer;
        this.z1v_1 = valueSerializer;
      }
      a1w(decoder, builder, startIndex, size) {
        // Inline function 'kotlin.require' call
        if (!(size >= 0)) {
          var message = 'Size must be known in advance when using READ_ALL';
          throw IllegalArgumentException().n2(toString(message));
        }
        var progression = step(until(0, imul(size, 2)), 2);
        var inductionVariable = progression.q3_1;
        var last = progression.r3_1;
        var step_0 = progression.s3_1;
        if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + step_0 | 0;
            this.b1w(decoder, startIndex + index | 0, builder, false);
          }
           while (!(index === last));
      }
      w1u(decoder, builder, startIndex, size) {
        return this.a1w(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap()) : false) ? builder : THROW_CCE(), startIndex, size);
      }
      b1w(decoder, index, builder, checkIndex) {
        var key = decoder.q1r(this.m1m(), index, this.y1v_1);
        var tmp;
        if (checkIndex) {
          // Inline function 'kotlin.also' call
          var this_0 = decoder.u1r(this.m1m());
          // Inline function 'kotlin.require' call
          if (!(this_0 === (index + 1 | 0))) {
            var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
            throw IllegalArgumentException().n2(toString(message));
          }
          tmp = this_0;
        } else {
          tmp = index + 1 | 0;
        }
        var vIndex = tmp;
        var tmp_0;
        var tmp_1;
        if (builder.s4(key)) {
          var tmp_2 = this.z1v_1.m1m().i1p();
          tmp_1 = !(tmp_2 instanceof PrimitiveKind());
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = decoder.p1r(this.m1m(), vIndex, this.z1v_1, getValue(builder, key));
        } else {
          tmp_0 = decoder.q1r(this.m1m(), vIndex, this.z1v_1);
        }
        var value = tmp_0;
        // Inline function 'kotlin.collections.set' call
        builder.x4(key, value);
      }
      x1u(decoder, index, builder, checkIndex) {
        return this.b1w(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap()) : false) ? builder : THROW_CCE(), checkIndex);
      }
      v1u(encoder, value) {
        var size = this.r1v(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.m1m();
        var composite = encoder.a1t(descriptor, size);
        var iterator = this.t1v(value);
        var index = 0;
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = iterator;
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          // Inline function 'kotlin.collections.component1' call
          var k = element.m3();
          // Inline function 'kotlin.collections.component2' call
          var v = element.n3();
          var tmp = this.m1m();
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          composite.v1s(tmp, _unary__edvuaz, this.y1v_1, k);
          var tmp_0 = this.m1m();
          var _unary__edvuaz_0 = index;
          index = _unary__edvuaz_0 + 1 | 0;
          composite.v1s(tmp_0, _unary__edvuaz_0, this.z1v_1, v);
        }
        composite.e1r(descriptor);
      }
      n1m(encoder, value) {
        return this.v1u(encoder, value);
      }
    }
    initMetadataForClass($, 'MapLikeSerializer');
    MapLikeSerializerClass = $;
  }
  return MapLikeSerializerClass;
}
var CollectionLikeSerializerClass;
function CollectionLikeSerializer() {
  if (CollectionLikeSerializerClass === VOID) {
    class $ extends AbstractCollectionSerializer() {
      constructor(elementSerializer) {
        super();
        this.u1u_1 = elementSerializer;
      }
      v1u(encoder, value) {
        var size = this.r1v(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.m1m();
        var composite = encoder.a1t(descriptor, size);
        var iterator = this.t1v(value);
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            composite.v1s(this.m1m(), index, this.u1u_1, iterator.r1());
          }
           while (inductionVariable < size);
        composite.e1r(descriptor);
      }
      n1m(encoder, value) {
        return this.v1u(encoder, value);
      }
      w1u(decoder, builder, startIndex, size) {
        // Inline function 'kotlin.require' call
        if (!(size >= 0)) {
          var message = 'Size must be known in advance when using READ_ALL';
          throw IllegalArgumentException().n2(toString(message));
        }
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.x1u(decoder, startIndex + index | 0, builder, false);
          }
           while (inductionVariable < size);
      }
      x1u(decoder, index, builder, checkIndex) {
        this.q1u(builder, index, decoder.q1r(this.m1m(), index, this.u1u_1));
      }
    }
    initMetadataForClass($, 'CollectionLikeSerializer');
    CollectionLikeSerializerClass = $;
  }
  return CollectionLikeSerializerClass;
}
function readSize($this, decoder, builder) {
  var size = decoder.v1r($this.m1m());
  $this.o1u(builder, size);
  return size;
}
var AbstractCollectionSerializerClass;
function AbstractCollectionSerializer() {
  if (AbstractCollectionSerializerClass === VOID) {
    class $ {
      z1u(decoder, previous) {
        var tmp1_elvis_lhs = previous == null ? null : this.m1u(previous);
        var builder = tmp1_elvis_lhs == null ? this.g1u() : tmp1_elvis_lhs;
        var startIndex = this.i1u(builder);
        var compositeDecoder = decoder.d1r(this.m1m());
        if (compositeDecoder.t1r()) {
          this.w1u(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
        } else {
          $l$loop: while (true) {
            var index = compositeDecoder.u1r(this.m1m());
            if (index === -1)
              break $l$loop;
            this.y1u(compositeDecoder, startIndex + index | 0, builder);
          }
        }
        compositeDecoder.e1r(this.m1m());
        return this.k1u(builder);
      }
      o1m(decoder) {
        return this.z1u(decoder, null);
      }
      y1u(decoder, index, builder, checkIndex, $super) {
        checkIndex = checkIndex === VOID ? true : checkIndex;
        var tmp;
        if ($super === VOID) {
          this.x1u(decoder, index, builder, checkIndex);
          tmp = Unit_instance;
        } else {
          tmp = $super.x1u.call(this, decoder, index, builder, checkIndex);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer()]);
    AbstractCollectionSerializerClass = $;
  }
  return AbstractCollectionSerializerClass;
}
var PrimitiveArraySerializerClass;
function PrimitiveArraySerializer() {
  if (PrimitiveArraySerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      constructor(primitiveSerializer) {
        super(primitiveSerializer);
        this.t1w_1 = new (PrimitiveArrayDescriptor())(primitiveSerializer.m1m());
      }
      m1m() {
        return this.t1w_1;
      }
      u1w(_this__u8e3s4) {
        return _this__u8e3s4.v1w();
      }
      i1u(_this__u8e3s4) {
        return this.u1w(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE());
      }
      w1w(_this__u8e3s4) {
        return _this__u8e3s4.x1w();
      }
      k1u(_this__u8e3s4) {
        return this.w1w(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE());
      }
      y1w(_this__u8e3s4, size) {
        return _this__u8e3s4.z1w(size);
      }
      o1u(_this__u8e3s4, size) {
        return this.y1w(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      a1x(_this__u8e3s4) {
        // Inline function 'kotlin.error' call
        var message = 'This method lead to boxing and must not be used, use writeContents instead';
        throw IllegalStateException().o(toString(message));
      }
      t1v(_this__u8e3s4) {
        return this.a1x(_this__u8e3s4);
      }
      b1x(_this__u8e3s4, index, element) {
        // Inline function 'kotlin.error' call
        var message = 'This method lead to boxing and must not be used, use Builder.append instead';
        throw IllegalStateException().o(toString(message));
      }
      q1u(_this__u8e3s4, index, element) {
        return this.b1x(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
      g1u() {
        return this.m1u(this.c1x());
      }
      f1x(encoder, value) {
        var size = this.r1v(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.t1w_1;
        var composite = encoder.a1t(descriptor, size);
        this.e1x(composite, value, size);
        composite.e1r(descriptor);
      }
      n1m(encoder, value) {
        return this.f1x(encoder, value);
      }
      v1u(encoder, value) {
        return this.f1x(encoder, value);
      }
      o1m(decoder) {
        return this.z1u(decoder, null);
      }
    }
    initMetadataForClass($, 'PrimitiveArraySerializer');
    PrimitiveArraySerializerClass = $;
  }
  return PrimitiveArraySerializerClass;
}
var PrimitiveArrayBuilderClass;
function PrimitiveArrayBuilder() {
  if (PrimitiveArrayBuilderClass === VOID) {
    class $ {
      g1x(requiredCapacity, $super) {
        requiredCapacity = requiredCapacity === VOID ? this.v1w() + 1 | 0 : requiredCapacity;
        var tmp;
        if ($super === VOID) {
          this.z1w(requiredCapacity);
          tmp = Unit_instance;
        } else {
          tmp = $super.z1w.call(this, requiredCapacity);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'PrimitiveArrayBuilder');
    PrimitiveArrayBuilderClass = $;
  }
  return PrimitiveArrayBuilderClass;
}
//region block: exports
export {
  ArrayListSerializer as ArrayListSerializer7k5wnrulb3y6,
  HashMapSerializer as HashMapSerializer10v33y6rrzgrh,
  HashSetSerializer as HashSetSerializer1nieavib0jif1,
  LinkedHashMapSerializer as LinkedHashMapSerializermaoj2nyji7op,
  LinkedHashSetSerializer as LinkedHashSetSerializer3ncla559t2lx7,
  PrimitiveArrayBuilder as PrimitiveArrayBuilder1tzna3i4eqw54,
  PrimitiveArraySerializer as PrimitiveArraySerializer6xcmeltdozbx,
  ReferenceArraySerializer as ReferenceArraySerializer3juj1vqolxkrs,
};
//endregion

//# sourceMappingURL=CollectionSerializers.mjs.map
